import { getDescriptionId, getFeedbackErrorId } from './field';

interface GetAriaDescribedByForInputFieldOptions {
  description?: string;
  error?: string | null;
  fieldId: string;
}

export const getAriaDescribedByForInputField = ({
  description,
  error,
  fieldId,
}: GetAriaDescribedByForInputFieldOptions) => {
  const hasError = Boolean(error);
  const hasDescription = Boolean(description);

  if (hasError && hasDescription) {
    return `${getFeedbackErrorId(fieldId)} ${getDescriptionId(fieldId)}`;
  } else if (hasError) {
    return getFeedbackErrorId(fieldId);
  } else if (hasDescription) {
    return getDescriptionId(fieldId);
  }

  return undefined;
};
